import { createSelector } from 'reselect';

import { getCurrentUserAdditionalData, getFirstDealerIdOfCurrentUser } from 'modules/users/selectors/currentUser';
import { getCountryByDealerId } from 'selectors/dealerSelectors';
import { phoneNumberStringToObject } from 'utils/PhoneNumberUtils';

const getState = (state) => state;

/**
 * @param {Object} state
 * @returns {import('../reducers').ReportIssuesReducer}
 */
const getReportIssuesState = state => state.reportIssues;

const getUiState = createSelector(getReportIssuesState, (data) => data.ui);

export const isModalOpen = createSelector(getUiState, state => state.isOpen);

/**
 * @param {Object} state
 * @returns {boolean}
 */
export const isCreateTicketLoading = createSelector(getUiState, (data) => Boolean(data.loading));

const getDefaultCountry = createSelector(getState, getFirstDealerIdOfCurrentUser, getCountryByDealerId);

export const getReportIssueInitialValues = createSelector(
  getCurrentUserAdditionalData,
  getFirstDealerIdOfCurrentUser,
  getDefaultCountry,
  (currentUserAdditionalData, defaultDealerId, defaultCountry) => ({
    dealerId: defaultDealerId,
    customer: {
      firstName: currentUserAdditionalData?.firstName,
      lastName: currentUserAdditionalData?.lastName,
      email: currentUserAdditionalData?.email,
      phoneNumber: currentUserAdditionalData?.tel
        ? phoneNumberStringToObject(currentUserAdditionalData?.tel)
        : {
          prefix: defaultCountry?.prefix.toString(),
        }
    },
  })
);
